import Resource from './Resource';
import _ from 'lodash';

function sortBasedOnArray(parentArray) {
    const orderArray = ['coins', 'supplies', 'marble', 'steel', 'planks', 'crystal', 'scrolls', 'silk', 'elixir', 'magicDust', 'gem', 'orc', 'mana', 'divineSeeds', 'moonstone', 'platinum', 'elvenTreeGum', 'obsidian', 'arcaneInk', 'velvet', 'sillySoap', 'alloyShrooms', 'cosmicBismuth'];
    return parentArray.sort((a, b) => {
        let indexA = orderArray.indexOf(a);
        let indexB = orderArray.indexOf(b);
        if (indexA === -1) indexA = Infinity;
        if (indexB === -1) indexB = Infinity;
        return indexA - indexB;
    });
}

// coins/supplies are always selected, so they sit in their own row above the
// pickable groups — that also drops a column, which portrait phones need.
const lockedResources = ['coins', 'supplies'];

const resourceGroups = [
    ['marble', 'steel', 'planks'],
    ['crystal', 'scrolls', 'silk'],
    ['elixir', 'magicDust', 'gem'],
    ['orc', 'mana', 'divineSeeds'],
    ['moonstone', 'platinum', 'elvenTreeGum'],
    ['obsidian', 'arcaneInk', 'velvet'],
    ['sillySoap', 'alloyShrooms', 'cosmicBismuth'],
];

function SelectResources({ resources, setResources }) {
  const handleClick = (resource) => {
      if (lockedResources.includes(resource)) return;
      if (_.includes(resources, resource)) {
        setResources(sortBasedOnArray(_.without(resources, resource)));
      } else {
        setResources(sortBasedOnArray([...resources, resource]));
      }
  };

  const sufficient = resources.length >= 3 && resources.length <= 8;

  return (
    <div className="flex flex-col items-center gap-3 md:gap-5">
        <div className="flex items-center gap-3">
            <h1 className="text-white/80 text-sm md:text-lg font-semibold tracking-wide uppercase m-0">Choose Resources</h1>
            <span className={`text-xs md:text-sm font-bold px-2.5 py-0.5 rounded-full ${sufficient ? 'bg-primary/20 text-primary' : 'bg-status-red/20 text-status-red'}`}>
                {resources.length} / 3-8
            </span>
        </div>

        <div className="flex items-center gap-1 md:gap-2">
            {lockedResources.map((res) => (
                <Resource
                    key={res}
                    value={res}
                    active={_.includes(resources, res)}
                    locked
                    onClick={() => handleClick(res)} />
            ))}
        </div>

        <div className="flex gap-1 md:gap-2">
            {resourceGroups.map((group, gi) => (
                <div key={gi} className={`flex flex-col gap-1 md:gap-2 justify-center ${gi === 3 || gi === 4 ? 'ml-1.5 md:ml-3' : ''}`}>
                    {group.map((res) => (
                        <Resource
                            key={res}
                            value={res}
                            active={_.includes(resources, res)}
                            locked={lockedResources.includes(res)}
                            onClick={() => handleClick(res)} />
                    ))}
                </div>
            ))}
        </div>
    </div>
  );
}

export default SelectResources;
